// extracted by mini-css-extract-plugin
export default {"featureListContainer":"FeatureList_solo_featureListContainer__r39YS","successIcon":"FeatureList_solo_successIcon__V5Ed2"};